import React from 'react'
import '../../assets/home/engagement.css'

function Engagement() {
  return (
    <div className="engagement container">
        <div className="cat-header">
            <h4 className='cat-subtitle'>DÉCOUVREZ NOS</h4>
            <h3 className='cat-title'>ENGAGEMENTS</h3>
        </div>
        <div className="eng-body">
            <div className="eng-item">
              <img src="./images/engagement1.png" alt="" />
            </div>
            <div className="eng-item" >
              <img src="./images/engagement2.png" alt="" />
            </div>
            <div className="eng-item" >
              <img src="./images/engagement3.png" alt="" />
            </div>
        </div>
    </div>
  )
}

export default Engagement